/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The type of home page to display.
 * Stored in DB as varchar(25)
 */
export enum HomePageType {
    DEFAULT = 'Default',
    WORKFLOWS = 'Workflows',
}
